import { Pipe, PipeTransform } from '@angular/core';

/** A chunk of text, flagged if it matches the current search query. */
export interface HighlightSegment {
  text: string;
  matched: boolean;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
}

/**
 * Splits `value` into segments around (case-insensitive) occurrences of `query`, so a template
 * can render the matched parts highlighted without using `innerHTML`.
 */
@Pipe({ name: 'highlightMatch' })
export class HighlightMatchPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    query: string | null | undefined
  ): HighlightSegment[] {
    const text = value ?? '';
    const trimmedQuery = query?.trim() ?? '';
    if (!text || !trimmedQuery) {
      return [{ text, matched: false }];
    }

    const parts = text.split(new RegExp(`(${escapeRegExp(trimmedQuery)})`, 'gi'));
    return parts
      .filter(part => part !== '')
      .map(part => ({ text: part, matched: part.toLowerCase() === trimmedQuery.toLowerCase() }));
  }
}
